import { FC } from 'react';

import { StaticNumericSpan } from '@myn/mui';

import { NumberFieldProps } from '../types.js';

type Props = Omit<NumberFieldProps, 'variant' | 'scale' | 'color'>;

const NumberVariant: FC<Props> = ({
  value,
  decimalLimit,
  isEmptyValueHidden = false,
  prefix,
}) => {
  const isValidValue = !!value || value === 0;

  if (isEmptyValueHidden || !isValidValue) {
    return null;
  }

  return (
    <StaticNumericSpan
      number={value}
      options={{
        minDecimals: decimalLimit,
        maxDecimals: decimalLimit,
        min: 0,
        prefix,
      }}
    />
  );
};
export default NumberVariant;
